export const STRUCTURES = "STRUCTURES";

export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";

export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const LOAD_PREFERENCES = "LOAD_PREFERENCES";
export const HANDLE_DARK_PREFERENCE = "HANDLE_DARK_PREFERENCE";
